import './terms.css';

function Terms() {
    return(
        <section id="terms-of-service" className="terms-of-service-section">
            <h2>Conditions d'Utilisation</h2>
            <p><strong>Acceptation des Conditions :</strong> En accédant et en utilisant notre site, vous acceptez de vous conformer aux conditions d'utilisation décrites ici.</p>
            <p><strong>Propriété Intellectuelle :</strong> Tous les contenus présents sur ce site sont protégés par les droits d'auteur. Vous ne pouvez pas reproduire, distribuer ou utiliser ces contenus sans notre autorisation.</p>
            <p><strong>Responsabilité :</strong> Nous ne pouvons être tenus responsables des dommages indirects, spéciaux ou consécutifs liés à l'utilisation de notre site.</p>
            <p><strong>Modifications :</strong> Nous nous réservons le droit de modifier ces conditions à tout moment. Les changements seront publiés sur cette page.</p>
            <p><strong>Contact :</strong> Pour toute question concernant les conditions d'utilisation, veuillez nous contacter à <a href="mailto:armorwebcreations@gmail.com">armorwebcreations@gmail.com</a>.</p>
        </section>
    )
}
export default Terms;